import {Dialog, Transition} from '@headlessui/react';
import React, {useState, Fragment, useRef, useEffect} from 'react';
import {ExclamationTriangleIcon} from '@heroicons/react/24/outline';
import {ShieldCheckIcon} from '@heroicons/react/24/outline';
import CloseIcon from '@mui/icons-material/Close';
import {useTranslation} from 'react-i18next';
import SelectComponent from '../../../Selects/SelectSpace';
import {getEstadosAprovacao} from '../../api';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from 'react-toastify';

// import { Container } from './styles';

function AprovacaoModal({cancelar, aprovar}) {
    const cancelButtonRef = useRef(null);
    const {t} = useTranslation();
    const [opcoesAprovacao, setOpcoesAprovacao] = useState([]);
    const [aprovacao, setAprovacao] = useState(null);
    const [justificacao, setJustificacao] = useState('');

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    useEffect(() => {
        getEstadosAprovacao(lang).then(res => {
            setOpcoesAprovacao(res.data.estadosAprovacao);
        });
    }, []);

    return (
        <Transition.Root show as={Fragment}>
            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={() => cancelar()}>
                <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                            <Dialog.Panel className="relative transform overflow-hidden rounded-[8px] bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                <div className="flex items-center justify-between px-4 py-2 border-b rounded-t bg-gray-50 border-gray-100">
                                    <div className="flex flex-row">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <ShieldCheckIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
                                        </div>
                                        <h3 className="text-xl ml-4 mt-2 font-semibold text-gray-600 ">{t('aprovacao')}</h3>
                                    </div>
                                    <button
                                        type="button"
                                        className="inline-flex justify-end rounded-[8px] text-gray-500 px-1 py-1 text-sm font-semibold  shadow-sm hover:bg-gray-200 sm:ml-3 sm:w-auto"
                                        onClick={() => cancelar()}>
                                        <CloseIcon />
                                    </button>
                                </div>
                                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                    {/* <div className="sm:flex sm:items-start"> */}
                                    {/* <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <ShieldCheckIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
                                        </div> */}
                                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                        {/* <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                                                {t('aprovacao')}
                                            </Dialog.Title> */}

                                        <form>
                                            <div className="mb-6">
                                                <div>
                                                    <label htmlFor="aprovacao" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white ">
                                                        {t('desejaAprovar')}
                                                    </label>
                                                    <div className="flex w-full">
                                                        <SelectComponent
                                                            id={'aprovacao'}
                                                            options={opcoesAprovacao}
                                                            value={aprovacao}
                                                            onChange={e => {
                                                                setAprovacao(e);
                                                            }}
                                                            noOptionsMessage={t('semopcoes')}
                                                            placeholder={t('selecioneOpcao')}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {aprovacao?.value == 2 && (
                                                <div className="mb-3 ">
                                                    <div>
                                                        <label htmlFor="justificacao" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                            {t('motivoNAprovacao')}
                                                        </label>
                                                        <textarea
                                                            id="justificacao"
                                                            rows="1"
                                                            maxLength={250}
                                                            value={justificacao}
                                                            onChange={e => {
                                                                setJustificacao(e.target.value);
                                                            }}
                                                            className={`block p-2.5 w-full text-sm text-gray-900 rounded-[8px] border border-gray-300 focus:ring-blue-500 focus:border-blue-500  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${'bg-white dark:bg-gray-900'} `}
                                                            placeholder={t('escrevaDescricao')}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </form>
                                    </div>
                                    {/* </div> */}
                                </div>
                                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                    <button
                                        type="button"
                                        disabled={!aprovacao}
                                        className="inline-flex w-full justify-center rounded-[8px] bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                                        onClick={() => {
                                            if (!aprovacao) return;

                                            if (aprovacao.value == 2 && !justificacao) {
                                                toast.error(t('motivoNAprovacao'), {
                                                    position: 'top-right',
                                                    autoClose: 5000,
                                                });
                                                return;
                                            }
                                            aprovar(aprovacao.value, justificacao).then(() => {
                                                toast.success(t('aprovado'), {
                                                    position: 'top-right',
                                                    autoClose: 5000,
                                                });
                                            });
                                        }}>
                                        {t('guardar')}
                                    </button>
                                    <button
                                        type="button"
                                        className="mt-3 inline-flex w-full justify-center rounded-[8px] bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                        onClick={() => cancelar()}
                                        ref={cancelButtonRef}>
                                        {t('cancelar')}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}

export default AprovacaoModal;
